// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title_img":"title_img-3pyZKUyu","title_img_info":"title_img_info-HP9IgV4e","long_info":"long_info-1-FURHtG","short_info":"short_info-WFefQttc"};